import React from 'react';
import { ShoppingBag, UtensilsCrossed, Coffee, Hotel, Briefcase } from 'lucide-react';

export const IndustriesSection = () => {
  const industries = [
    {
      icon: <ShoppingBag size={40} />,
      title: 'Retail',
      description: 'Ideal for retail stores, boutiques, and shopping outlets seeking modern payment solutions',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxyZXRhaWwlMjBzdG9yZXxlbnwwfHx8fDE3NzkxMjc5NzN8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: <UtensilsCrossed size={40} />,
      title: 'Restaurants',
      description: 'A natural fit for restaurants looking for fast, secure payment processing at the table',
      image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxyZXN0YXVyYW50fGVufDB8fHx8MTc3OTEyNzk3M3ww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: <Coffee size={40} />,
      title: 'Cafés',
      description: 'Designed for coffee shops and casual venues that need quick contactless checkout',
      image: 'https://images.unsplash.com/photo-1567880905822-56f8e06fe630?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxjYWZlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc5MTI3OTg2fDA&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: <Hotel size={40} />,
      title: 'Hospitality',
      description: 'Built for hotels and hospitality teams that value reliable, modern payment workflows',
      image: 'https://images.unsplash.com/photo-1551632436-cbf8dd35adfa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxob3NwaXRhbGl0eSUyMGhvdGVsfGVufDB8fHx8MTc3OTEyNzk3M3ww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: <Briefcase size={40} />,
      title: 'Service Businesses',
      description: 'A great match for service-based SMEs that want flexible, on-the-go payment options',
      image: 'https://images.unsplash.com/photo-1556742031-c6961e8560b0'
    }
  ];

  return (
    <section id="industries" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Suggested <span className="gradient-text">Clients</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            The kinds of businesses Syrveo is designed for
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="card-hover group relative overflow-hidden rounded-2xl shadow-lg"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={industry.image}
                  alt={industry.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128] via-[#0A1128]/70 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <div className="text-[#10B981] mb-3">{industry.icon}</div>
                <h3 className="text-2xl font-bold mb-2">{industry.title}</h3>
                <p className="text-gray-200">{industry.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
